module.exports = __webpack_public_path__ + "static/media/ywing.c774bcc2.png";